const Pay = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 40 40"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.9759 30V12M19.9759 12L27 18.0811M19.9759 12L13 18.0811"
      stroke="white"
      strokeWidth="3"
      strokeLinecap="round"
    />
    <path
      d="M4 35C4 32.2386 6.23858 30 9 30H31C33.7614 30 36 32.2386 36 35V40H4V35Z"
      fill="url(#paint0_linear_827_15652)"
    />
    <defs>
      <linearGradient
        id="paint0_linear_827_15652"
        x1="20"
        y1="30"
        x2="20"
        y2="40"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="white" />
        <stop offset="1" stopColor="white" stopOpacity="0.4" />
      </linearGradient>
    </defs>
  </svg>
);

export default Pay;
